"use client";

import React from "react";
import { Loader, Mail, CircleCheck } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-6 text-center animate-in fade-in zoom-in duration-500">
        <div className="bg-primary/10 p-3 rounded-full mb-4">
          <CircleCheck className="size-8 text-primary" />
        </div>
        <h3 className="font-serif text-xl font-bold text-foreground mb-2">
          Welcome to the Club
        </h3>
        <p className="font-sans text-foreground/80 mb-6">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="font-serif border-border text-foreground hover:bg-foreground hover:text-background transition-colors">
          Subscribe Another Email
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto">
      <div className="flex flex-col sm:flex-row gap-4">
        <FormField control={control} name="email" rules={{
        required: "Email address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem className="flex-1">
              <FormControl>
                <div className="relative group">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-foreground/50 size-5 transition-colors group-focus-within:text-primary" />
                  <Input type="email" placeholder="Enter your email address" className="pl-12 h-14 bg-background border-border text-foreground placeholder:text-foreground/50 font-sans text-base rounded-lg focus-visible:ring-primary focus-visible:border-primary transition-all" {...field} />
                </div>
              </FormControl>
              <FormMessage className="font-sans text-destructive mt-2" />
            </FormItem>} />

        <Button type="submit" disabled={isSubmitting} className="h-14 px-8 font-serif text-base font-bold bg-primary text-primary-foreground rounded-lg border border-transparent hover:bg-primary hover:border-border hover:-translate-y-1 hover:shadow-lg transition-all duration-300 sm:w-auto w-full">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Processing...
            </> : "Subscribe"}
        </Button>
      </div>

      {submitError && <div className="mt-4 p-4 bg-destructive/10 border border-destructive/20 rounded-lg text-center">
          <p className="font-sans text-destructive text-sm">{submitError}</p>
        </div>}
    </Form>;
}
export default function Newsletter() {
  return <section id="newsletter" className="bg-background py-16 md:py-24 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="bg-card border border-border rounded-2xl p-8 md:p-12 lg:p-16 shadow-2xl relative overflow-hidden">
            {}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-primary/30 rounded-tl-2xl pointer-events-none" />
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-primary/30 rounded-br-2xl pointer-events-none" />

            <div className="text-center mb-10">
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 tracking-wide">
                Join The High Score Club
              </h2>
              <p className="font-sans text-foreground/80 text-base md:text-lg max-w-2xl mx-auto">
                Get exclusive updates on new releases and arcade events.
              </p>
            </div>

            <FormProvider formId="newsletter_signup_home" sectionName="Newsletter" defaultValues={{
            email: ""
          }} submitText="Subscribe" successMessage="You've successfully joined The High Score Club! Keep an eye on your inbox.">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}